
import { Component, Prop, Watch } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ProjectMixin from '@/_mixins/project'

@Component({
    mixins: [ProjectMixin],
})
export default class SelectDashboard extends Mixins<MixinInterface>(ProjectMixin) {
    get items() {
        return this.$store.getters.dashboards
    }

    id: any = null

    get project() {
        return this.$route.params.type == 'p'
            ? this.$store.getters.project(this.$route.params.id)
            : null
    }

    get group() {
        return this.$route.params.type == 'g'
            ? this.$store.getters.group(this.$route.params.id)
            : null
    }

    get routeId() {
        return
    }

    async addItem() {
        let id = await this.createDashboard()
        if (id) {
            this.id = id
            this.$router.push({ name: 'dashboardId', params: { dashboardId: id } })
        }
    }

    async createDashboard() {
        let payload = {
            type: 'dashboard',
            name: `${this.$t('project_menu.dashboard')}-${Object.values(this.items).length}`,
            ...(this.group && {
                projectGroup: {
                    data: {
                        type: 'projectGroup',
                        id: this.group.id,
                    },
                },
            }),
            ...(this.project && {
                project: {
                    data: {
                        type: 'project',
                        id: this.project.id,
                    },
                },
            }),
        }
        const dashboard = await this.postDashboard(payload)
        if (dashboard?.id) {
            return dashboard.id
        } else {
            return null
        }
    }

    navigateTo(id) {
        this.$emit('navigateTo', { name: 'dashboardId', params: { dashboardId: id } })
    }

    @Watch('$route.params.dashboardId', { immediate: true })
    setId() {
        this.id = this.$route.params.dashboardId
    }
}
